function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import { getRuntimeConfig } from "./api";
let configFetchTask = null;
let cachedQueryArgs = {};
function isPrimitive(obj) {
  return obj !== Object(obj);
}
function isConfigEqual(config1, config2) {
  if (config1 === config2) {
    return true;
  }
  if (isPrimitive(config1) && isPrimitive(config2)) {
    return config1 === config2;
  }
  if (Object.keys(config1).length !== Object.keys(config2).length) {
    return false;
  }
  for (const key in config1) {
    if (!(key in config2)) {
      return false;
    }
    if (!isConfigEqual(config1[key], config2[key])) {
      return false;
    }
  }
  return true;
}
function fetchRuntimeConfig(query) {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }
  if (!query) {
    query = cachedQueryArgs;
  } else {
    query = _object_spread({}, cachedQueryArgs, query);
  }
  if (configFetchTask && isConfigEqual(query, cachedQueryArgs)) {
    return configFetchTask;
  }
  cachedQueryArgs = query;
  configFetchTask = getRuntimeConfig(query);
  return configFetchTask;
}
function getRuntimeQuery() {
  return cachedQueryArgs;
}
export {
  fetchRuntimeConfig,
  getRuntimeQuery
};
